export enum TransparentLogoIconName {
  TransparentAboutYouLogo = 'TransparentAboutYouLogo',
}

export const transparentLogoIconAssets: {
  [key in TransparentLogoIconName]: string;
} = {
  [TransparentLogoIconName.TransparentAboutYouLogo]: require('./ay-logo-white-transp.svg'),
};
